module.exports = __webpack_public_path__ + "img/中通兔喜.75ca913a.png";